document.addEventListener('DOMContentLoaded', () => {
  const run = document.getElementsByClassName('page-container search');

  let selectedType = 'all';

  let term = null;

  const ghostResults = document.getElementById('ghost-results');
  const ghostResultsSummary = document.getElementById('ghost-results-summary');
  const results = document.getElementById('results');
  const resultsSummary = document.getElementById('results-summary');

  const setLoading = () => {
    ghostResultsSummary.classList.remove('hidden')
    ghostResults.classList.remove('hidden')
    results.classList.add('hidden')
    resultsSummary.classList.add('hidden')
  };

  const setLoaded = () => {
    ghostResultsSummary.classList.add('hidden')
    ghostResults.classList.add('hidden')
    results.classList.remove('hidden')
    resultsSummary.classList.remove('hidden')
    document.querySelector('a[data-type="all"').click();
  };

  const setResultsSummary = (term, count) => {
    resultsSummary.innerHTML =
      `${count} results for '<span class="text-primary-100">${term}</span>'`;
  }

  const setResults = (response) => {
    results.innerHTML = response;
  };

  const checkNoResults = () => {
    // Check to see if any results are visible
    results.classList.remove('no-results');

    const noResults = document.querySelectorAll('.result:not(.hidden').length === 0

    if(noResults) {
      results.classList.add('no-results');
    }
  };

  const filterResults = () => {
    const results = document.getElementsByClassName('result');

    Array.from(results).forEach(result => result.classList.add('hidden'));

    const resultsToShow = document.getElementsByClassName(selectedType === 'all' ? 'result' : selectedType);

    Array.from(resultsToShow).forEach((result) => result.classList.remove('hidden'));

    checkNoResults();
  };

  const fetchResults = () => {
    const grades = Array.from(document.querySelectorAll('.filter.grade:checked')).map((element) => element.value);
    const topics = Array.from(document.querySelectorAll('.filter.topic:checked')).map((element) => element.value);

    const params = new URLSearchParams({
      term: term,
    });

    if(grades.length > 0) {
      params.set('grades', grades);
    }

    if(topics.length > 0) {
      params.set('topics', topics);
    }

    fetch('/search/results?' + params.toString()).then((response) => {
      setResultsSummary(term, response.headers.get('X-RESULT-COUNT'));

      response.text().then((body) => {
        setResults(body);
        checkNoResults();
        setLoaded();
      });
    });
  };

  const onLoad = () => {
    const searchPanel = document.getElementById('search-results');

    // MOBILE FILTERS OPEN
    const openFiltersButton = document.getElementById('filters');
    const closeFiltersButton = document.getElementById('filters-close');
    const filters = document.getElementById('filters-sidebar');

    const toggleFilters = (e) => {
      e.preventDefault();

      filters.classList.toggle('hidden');
      searchPanel.classList.toggle('hidden');
    };

    openFiltersButton.addEventListener('click', (e) => {
      toggleFilters(e);
    });

    closeFiltersButton.addEventListener('click', (e) => {
      toggleFilters(e);
    });

    // TYPE PILLS
    const types = document.getElementsByClassName('type');
    const typeActiveClasses = ['bg-secondary-100', 'text-white', 'border-secondary-100'];
    const typeInactiveClasses = ['bg-white', 'text-grey-dark', 'border-grey-standard'];

    Array.from(types).forEach(type => {
      type.addEventListener('click', (e) => {
        e.preventDefault();

        Array.from(types).forEach(type => {
          typeActiveClasses.forEach(className => {
            type.classList.remove(className);
          });

          typeInactiveClasses.forEach(className => {
            type.classList.add(className);
          });
        });

        typeInactiveClasses.forEach(className => {
          type.classList.remove(className);
        });

        typeActiveClasses.forEach(className => {
          type.classList.add(className);
        });

        selectedType = type.dataset.type;
        filterResults();
      });
    });

    // FILTERS
    const queryFilters = document.querySelectorAll('.filter');

    Array.from(queryFilters).forEach((queryFilter) => {
      queryFilter.addEventListener('click', () => {
        fetchResults();
      });
    });
  };

  if (run.length > 0) {
    term = document.getElementById('term').value;

    onLoad();
    fetchResults();
  }
});
